import React, { useState, useEffect } from "react";
import { Button, Typography, Grid, Container, TextField } from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import api from "../../globals/axios";
import {
  SERVER_BASE_ADDRESS,
  AGRI_COMMODITY_TYPE_CONVENTION,
} from "../../globals/const";
import { getProcessingEmissions } from "../../globals/emissions";
import { getWalletFromLocal } from "../../globals/authentication";
import { getBlockchainNodeUrl } from "../../globals/const";
import CustomAppBar from "../../components/AppBar";

const styles = {
  icon: {
    marginRight: 2,
  },
  mainContent: {
    // backgroundColor: palette.background.paper,
    padding: 0.25,
    paddingLeft: 0.5,
    paddingRight: 0.5,
    flexGrow: 1,
  },
  row: {
    item: true,
    container: true,
    spacing: 1,
    justify: "center",
  },
  fab: {
    position: "fixed",
    bottom: 2,
    left: 2,
  },
  fabRow: {},
  fundSelectorRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  buttonRow: {
    margin: "10px",
    display: "flex",
    justifyContent: "space-around",
  },
};

export default function CreateProductRecipe() {
  const classes = styles;
  const [wallet, setWallet] = useState({});
  const [serialNumber, setSerialNumber] = useState("");
  const [productName, setProductName] = useState("");
  const [walletBalances, setWalletBalances] = useState([]);
  const [ingredients, setIngredients] = useState([]);
  const electricity = [];
  const [emission, setEmission] = useState([]);
  console.log(emission);

  useEffect(() => {
    const loadWallet = async () => {
      const w = await getWalletFromLocal();
      setWallet(w);
    };

    loadWallet();
  }, []);

  useEffect(() => {
    api
      .get(
        getBlockchainNodeUrl() +
          "/get-balances?balance_type=ALL_TOKENS_IN_WALLET&wallet_address=" +
          wallet.address
      )
      .then((res) => res.data.balance)
      .then((data) => {
        if (data[0]) {
          setWalletBalances(data);
        }
      });
  }, [wallet]);

  // adds token_type field into wallets and emissions if relevant
  useEffect(() => {
    const addTypeAttribute = async () => {
      const data = walletBalances;
      await data.map((token) => {
        api
          .get(
            getBlockchainNodeUrl() + "/get-token?token_code=" + token.token_code
          )
          .then((res) => res.data)
          .then((data) => {
            if (data.tokentype === AGRI_COMMODITY_TYPE_CONVENTION) {
              token.token_type = data.tokentype;
              token.carbon_emission = JSON.parse(
                data.token_attributes
              ).carbon_emission;
            } else {
              token.token_type = data.tokentype;
            }
          });
      });
      setWalletBalances(data);
    };

    addTypeAttribute();
  }, [walletBalances]);

  const createProduct = async () => {
    api
      .post(`${SERVER_BASE_ADDRESS}/foodprocessor/product-recipe`, {
        product_name: productName,
        serial_number: serialNumber,
        ingredients_json: ingredients,
      })
      .then((result) => {
        console.log(result);
        alert("Product Created Successfully");
        window.open("/product-recipes", "_self");
      })
      .catch((err) => {
        alert("Error - " + err.response.data.non_field_errors[0]);
      });
  };

  const _calculateAdditionalEmissions = (ingredients) => {
    let extraEmissions = 0;
    ingredients.forEach(sumEmissions);
    function sumEmissions(ingredient) {
      extraEmissions += ingredient.carbon_emission * ingredient.proportion;
    }
    return extraEmissions;
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div className={classes.mainContent}>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <Typography variant="h5">Create Product Recipe</Typography>

            <TextField
              margin="normal"
              required
              fullWidth
              name="txtamount"
              label="Product Name"
              id="txtamount"
              value={productName}
              onChange={(event) => setProductName(event.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="txtamount"
              label="Serial Number"
              id="txtamount"
              value={serialNumber}
              onChange={(event) => setSerialNumber(event.target.value)}
            />

            {ingredients.map((ig, idx) => (
              <Grid key={idx} container justifyContent="space-between">
                <Grid xs={8}>
                  <FormControl fullWidth sx={{ marginTop: 2 }}>
                    <InputLabel id="token-select-label">
                      Ingredient Type
                    </InputLabel>
                    <Select
                      labelId="token-select-label"
                      id="token-select"
                      value={ingredients[idx].token_code}
                      label="Ingredient Token"
                      onChange={(e) => {
                        const newIngredients = [...ingredients];
                        newIngredients[idx].type = e.target.value;
                        setIngredients(newIngredients);
                        setEmission(
                          getProcessingEmissions(
                            electricity,
                            _calculateAdditionalEmissions(newIngredients)
                          )
                        );
                      }}
                    >
                      {["Potato", "Salt", "Rice", "Flour", "Sugar"].map((b) => (
                        <MenuItem key={b} value={b}>
                          {b}
                        </MenuItem>
                      ))}
                      {/* ensures that only harvets are shown */}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid xs={4}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="txtamount"
                    label="Proportion"
                    type="number"
                    id="txtamount"
                    value={ingredients[idx].proportion}
                    onChange={(e) => {
                      const newIngredients = [...ingredients];
                      newIngredients[idx].proportion = e.target.value;
                      setIngredients(newIngredients);
                      setEmission(
                        getProcessingEmissions(
                          electricity,
                          _calculateAdditionalEmissions(newIngredients)
                        )
                      );
                    }}
                  />
                </Grid>
              </Grid>
            ))}

            <Button
              style={{ marginTop: 10 }}
              variant="outlined"
              size="small"
              color="primary"
              onClick={() => setIngredients([...ingredients, {}])}
            >
              Add Ingredient
            </Button>
            <Button
              style={{ marginTop: 10 }}
              variant="contained"
              size="small"
              color="primary"
              onClick={createProduct}
            >
              Create Product
            </Button>
          </Grid>
        </div>
      </Container>
    </>
  );
}
